import {PROFILE} from '../../actions/profile/profileActionTypes';

const INITIAL_STATE = {
    loading: true,
    profileMe: {},
    profileMeAvatar: [],
    userRoles: [],
    notifications: {
        loading: false,
        list: [],
        page: 1,
        hasMore: true,
        error: null,
    },
    notificationsNewCount: 0
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case PROFILE.GET_PROFILE_ME_SUCCESS:
            return {...state, profileMe: action.payload?.data?.data ?? {}, loading: false};


        case PROFILE.GET_PROFILE_ME_FAIL:
            return {...state, loading: false};

        case PROFILE.ADD_NOTIFICATION_PUSHER:
            return {
                ...state, notifications: {
                    ...state.notifications,
                    list: [action.payload, ...state.notifications.list]
                }
            };


        case PROFILE.CLEAR_NOTIFICATION_LIST:
            return {
                ...state, notifications: {
                    ...state.notifications,
                    list: []
                }
            };

        case PROFILE.PROFILE_REMOVE_NOTIFICATION_SUCCESS: {
            const id = action.payload?.config?.removeId

            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.filter(el => el.id !== id)
                },
                // notificationsNewCount: state.notificationsNewCount > 0 ? state.notificationsNewCount - 1 : 0
            }
        }

        case PROFILE.GET_PROFILE_ME_NOTIFICATIONS_SUCCESS:
            const data = action.payload.data;

            const withoutList = action.payload?.config?.withoutList
            const hasMore = data?.meta?.current_page < data?.meta.last_page;
            return {
                ...state, notifications: {
                    ...state.notifications,
                    list: !withoutList ? [...state.notifications.list, ...data.data] : [],
                    page: data?.meta?.current_page + 1,
                    total: data?.meta?.total,
                    hasMore: hasMore,

                }, notificationsNewCount: action.payload?.data?.newCount || 0
            };

        case PROFILE.PROFILE_UPDATE_NOTIFICATION_COUNT:
            const type = action.payload?.type
            let count = state.notificationsNewCount

            if (type === 'all') {
                count = 0
            }
            if (type === 'minus') {
                count = count - 1
            }
            if (type === 'plus') {
                count = count + 1
            }
            return {
                ...state,
                notificationsNewCount: count,
            };

        case PROFILE.PROFILE_READ__NOTIFICATION_PUSHER:
            const idNotification = action.payload;

            return {
                ...state,
                notificationsNewCount: Math.max(0, state.notificationsNewCount - 1),
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.map((el) => {
                        if (el.id === idNotification) {
                            return {
                                ...el,
                                isRead: true,
                            };
                        }
                        return el;
                    }),
                },
            };
        case PROFILE.PROFILE_DELETE_NOTIFICATION_PUSHER: {
            const idToDelete = action.payload;

            return {
                ...state,
                notificationsNewCount: Math.max(0, state.notificationsNewCount - 1),
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.filter((el) => el.id !== idToDelete),
                },
            };
        }

        case PROFILE.PROFILE_READ_ALL_NOTIFICATION_PUSHER_ALL:
            if(state.notificationsNewCount === 0) {
                return {
                    ...state,
                }
            }
            return {
                ...state,
                notificationsNewCount: 0,
                notifications: {
                    ...state.notifications,
                    list: state.notifications.list.map((el) => {
                        return {
                            ...el,
                            isRead: true
                        }
                    }),
                }
            };

        case PROFILE.GET_PROFILE_ME_AVATAR_SUCCESS:
            return {...state, profileMeAvatar: action.payload.data.data, loading: false};
        case PROFILE.GET_PROFILE_ME_AVATAR_FAIL:
            return {...state, loading: false};

        case PROFILE.GET_USER_ROLES_SUCCESS:
            return {...state, userRoles: action.payload.data.data, loading: false};
        case PROFILE.GET_USER_ROLES_FAIL:
            return {...state, loading: false};
        case PROFILE.CLEAR_USER_ROLES:
            return {...state, userRoles: [], loading: false};

        default:
            return state;
    }
}
